"use strict";

import Rails from "@rails/ujs";

// Init Rails UJS for data-confirm and data-disable-with
Rails.start();
